export default __webpack_public_path__ + "static/media/verificationPhone.205455d6.png";